import React from 'react'

export default function Settled() {
  return (
    <div>Settled</div>
  )
}
